export const PROPERTY_TYPE_GROUPS = [
  {
    label: 'Residenciales',
    options: [
      ['casa', 'Casa'], ['departamento', 'Departamento'], ['ph', 'PH'],
      ['duplex', 'Dúplex'], ['triplex', 'Tríplex'], ['loft', 'Loft'],
      ['monoambiente', 'Monoambiente'], ['quinta', 'Quinta'], ['cabana', 'Cabaña'],
    ],
  },
  {
    label: 'Terrenos y rurales',
    options: [
      ['lote', 'Lote / Terreno'], ['finca', 'Finca'], ['campo', 'Campo'], ['vinedo', 'Viñedo'],
    ],
  },
  {
    label: 'Comerciales',
    options: [
      ['local_comercial', 'Local comercial'], ['oficina', 'Oficina'],
      ['consultorio', 'Consultorio'], ['galpon', 'Galpón'], ['deposito', 'Depósito'],
      ['fondo_comercio', 'Fondo de comercio'],
    ],
  },
  {
    label: 'Especiales',
    options: [
      ['cochera', 'Cochera'], ['hotel', 'Hotel'], ['apart_hotel', 'Apart hotel'],
      ['complejo_turistico', 'Complejo turístico'],
    ],
  },
];

export const PROPERTY_TYPE_OPTIONS = PROPERTY_TYPE_GROUPS.flatMap((group) => group.options);
